import { TOGGLE_SIDE_MENU } from '../actions/constants';

const getDefaultState = () => {
  return {
    isSideMenuOpen: false,
    logoUrl: '',
  };
};

const defaultState = getDefaultState();

interface StateProps {
  isSideMenuOpen: boolean;
  logoUrl: string;
}

export default (state : StateProps = defaultState, action) => {
  switch (action.type) {
    case TOGGLE_SIDE_MENU: {
      return {
        ...state,
        isSideMenuOpen: !state.isSideMenuOpen,
      };
    }

    default:
      return state;
  }
};
